import React from "react";
import PropTypes from "prop-types";
import PaymentCard from "./PaymentCard";

const StoredPaymentMethods = (props) => {
    const {
        donorAccount: { paymentInfo = [] },
        savedPaymentMethodsSectionHeading,
    } = props;

    return (
        paymentInfo.length > 0 && (
            <div className="col col--12">
                <div className="qg-vendor-saved-payment-methods-container">
                    <div className="grid">
                        <div className="col col--12">
                            <h3 id="stored-payment-methods-header">
                                {savedPaymentMethodsSectionHeading}
                            </h3>
                            <ul
                                className="qg-vendor-stored-payment-methods grid"
                                role="listbox"
                                aria-labelledby="stored-payment-methods-header"
                            >
                                {paymentInfo.map((payment) => (
                                    <PaymentCard
                                        {...props}
                                        key={payment.id}
                                        payment={payment}
                                    />
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

StoredPaymentMethods.propTypes = {
    donorAccount: PropTypes.shape({
        paymentInfo: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    savedPaymentMethodsSectionHeading: PropTypes.string.isRequired,
};

export default StoredPaymentMethods;
